// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_71J","cls2":"TransactionalPricingModal-cls2_95x TransactionalPricingModal-cls1_71J"};